import { Component } from '@angular/core';

@Component({
  selector: 'doa-redirect',
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss'
})
export class RedirectComponent {

}
